(function () {
    // Cookie-Hilfsfunktionen - eigentlich muss noch Domain-Attribut gesetzt werden - wenn "auto", wird Cookie auf login. gesetzt - das wollen wir nicht
    function setCookie(name, value, days) {
        let cookieStr = name + "=" + encodeURIComponent(value) + "; path=/";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            cookieStr += "; expires=" + date.toUTCString();
        }
        document.cookie = cookieStr;
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    }

    // Analytics-Consent (Cookiebot "statistics") prüfen
    function hasAnalyticsConsent() {
        return window.Cookiebot?.consent?.statistics === true;
    }

    // Prüft ob Cookies bereits als 365-Tage-Cookies gesetzt wurden (nach Consent)
    function hasPersistentCookies() {
        return getCookie('_hero_tp_persistent') === '1';
    }

    function isDirect(referrer) {
        return !referrer || referrer === 'direct';
    }

    // UTM-Parameter aus URL extrahieren
    function extractUtmParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams = {};

        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_adgroup'];

        utmKeys.forEach(key => {
            const value = urlParams.get(key);
            if (value) {
                utmParams[key] = value;
            }
        });

        return Object.keys(utmParams).length > 0 ? utmParams : null;
    }

    // Referrer-Korrektur-Mapping
    // WICHTIG: Spezifischere Patterns MÜSSEN vor generischen Patterns stehen!
    const referrerMapping = [
        { "pattern": "google.", "target": "Google" },
        { "pattern": "bing.com", "target": "Bing" },
        // Staging-Domain MUSS vor hero-software.de stehen, da ".de" in ".dev" enthalten ist
        { "pattern": "hero-software.dev", "target": "Staging" },
        { "pattern": "facebook.com", "target": "Meta" },
        { "pattern": "instagram.com", "target": "Meta" },
        { "pattern": "googleads.g.doubleclick.net", "target": "Google" },
        { "pattern": "googleadservices.com", "target": "Google" },
        { "pattern": "safeframe.googlesyndication.com", "target": "Google" },
        { "pattern": "syndicatedsearch.goog", "target": "Google" },
        { "pattern": "android-app://com.google.android.googlequicksearchbox", "target": "Google" },
        { "pattern": "android-app://com.google.android.gm", "target": "Google" },
        { "pattern": "yahoo.com", "target": "Yahoo" },
        { "pattern": "capterra.com", "target": "Capterra" },
        { "pattern": "capterra.fr", "target": "Capterra" },
        { "pattern": "youtube.com", "target": "Youtube" },
        { "pattern": "pinterest.com", "target": "Pinterest" },
        { "pattern": "linkedin.com", "target": "LinkedIn" },
        { "pattern": "tiktok.com", "target": "TikTok" },
        { "pattern": "intern", "target": "direct" },
        { "pattern": "(direct)", "target": "direct" }
    ];

    // Own country domains and their subdomains (login., shop., ...) count as direct (WF-1995).
    // The check uses the hostname. hero-software.dev does not match and stays "Staging".
    const ownDomainPattern = /(^|\.)hero-software\.(de|at|ch|fr|nl|it|es|pl)$/;

    function isOwnDomain(documentReferrer) {
        try {
            return ownDomainPattern.test(new URL(documentReferrer).hostname);
        } catch (e) {
            return false;
        }
    }

    function getCorrectReferrer(documentReferrer) {
        if (isOwnDomain(documentReferrer)) return 'direct';
        const lowerRef = (documentReferrer || '').toLowerCase();
        for (const map of referrerMapping) {
            if (lowerRef.includes(map.pattern.toLowerCase())) {
                return map.target;
            }
        }
        // Default: original Referrer oder 'direct' wenn leer
        return documentReferrer || 'direct';
    }

    // Schreibt referrer, landingpage und utms (Non-Direct-Logik).
    // previous_url wird separat behandelt, da es auf jeder Seite aktualisiert wird.
    function writeAttributionCookies(referrerVal, landingpageVal, utmsVal, days) {
        setCookie('_hero_tp_referrer', referrerVal, days);
        if (landingpageVal !== null) setCookie('_hero_tp_landingpage', landingpageVal, days);
        if (utmsVal !== null) setCookie('_hero_tp_utms', utmsVal, days);
    }

    const isSignupPage = !!(
        document.getElementById("signup-form") ||
        document.getElementById("signup-page") ||
        document.getElementById("web-to-lead-form")
    );

    const currentReferrer = getCorrectReferrer(document.referrer);
    const currentLandingpage = window.location.origin + window.location.pathname;
    const currentPreviousUrl = window.location.origin + window.location.pathname;
    const currentUtms = extractUtmParameters();

    window._heroAttribution = {
        referrer: currentReferrer,
        landingpage: currentLandingpage,
        utms: currentUtms ? JSON.stringify(currentUtms) : null
    };

    const existingReferrer = getCookie('_hero_tp_referrer');
    const existingLandingpageCheck = getCookie('_hero_tp_landingpage');
    const hasExistingCookies = existingReferrer !== null && existingLandingpageCheck !== null;
    const persistent = hasPersistentCookies();
    const consent = hasAnalyticsConsent();
    const cookieDays = consent ? 365 : null;

    if (!hasExistingCookies) {
        // Erster Besuch: aktuelle Werte schreiben, egal ob direct oder nicht
        writeAttributionCookies(
            currentReferrer,
            currentLandingpage,
            currentUtms ? JSON.stringify(currentUtms) : null,
            cookieDays
        );
        if (consent) setCookie('_hero_tp_persistent', '1', 365);
    } else if (!isDirect(currentReferrer)) {
        // Nicht-direkter Folgebesuch: Werte überschreiben (außer: persistente Cookies ohne Consent)
        if (!(persistent && !consent)) {
            writeAttributionCookies(
                currentReferrer,
                currentLandingpage,
                currentUtms ? JSON.stringify(currentUtms) : null,
                cookieDays
            );
            if (!currentUtms) {
                setCookie('_hero_tp_utms', '', cookieDays);
            }
            if (consent) setCookie('_hero_tp_persistent', '1', 365);
        }
    } else if (consent) {
        // Direkter Besuch mit Consent: Laufzeit der bestehenden Cookies auf 365 Tage verlängern
        const existingUtms = getCookie('_hero_tp_utms');
        writeAttributionCookies(existingReferrer, existingLandingpageCheck, existingUtms, 365);
        setCookie('_hero_tp_persistent', '1', 365);
    }
    // Direkter Besuch ohne Consent: nichts ändern — Session-Cookies bleiben Session-Cookies,
    // persistente Cookies (persistent=true) werden nicht angetastet

    // UTM-Parameter überschreiben immer, sofern in der aktuellen URL gesetzt — unabhängig von Referrer und Consent
    if (currentUtms) {
        setCookie('_hero_tp_utms', JSON.stringify(currentUtms), cookieDays);
    }

    // previous_url: immer auf aktuelle Seite setzen (außer auf Signup-Seiten)
    // Laufzeit folgt dem consent-Status, aber der Wert wird bei jedem Seitenaufruf aktualisiert.
    // Sonderfall: persistent ohne Consent → nicht anfassen
    if (!isSignupPage) {
        if (!persistent || consent) {
            setCookie('_hero_tp_previous_url', currentPreviousUrl, cookieDays);
        }
    }

    // Click-ID URL-Parameter in Session-Cookies speichern (unabhängig vom Consent)
    // Diese Cookies werden immer gesetzt, wenn URL-Parameter vorhanden sind
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('gclid')) {
        setCookie('_hero_tp_gclid_param_set', 'true');
    }

    if (urlParams.get('msclkid')) {
        setCookie('_hero_tp_msclkid_param_set', 'true');
    }

    if (urlParams.get('fbclid')) {
        setCookie('_hero_tp_fbclid_param_set', 'true');
    }

    if (urlParams.get('epik') || urlParams.get('_epik')) {
        setCookie('_hero_tp_epik_param_set', 'true');
    }

    if (urlParams.get('ttclid')) {
        setCookie('_hero_tp_ttclid_param_set', 'true');
    }
})();
